import React, { useEffect, useState } from 'react';
import PriceChart from './PriceChart';
import PriceTable from './PriceTables/index.js';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import PriceDisclaimer from './PriceDisclaimer/index.js';

const PriceHistory = props => {
  const { t, i18n, name } = props;
  const {
    isSingleElement,
    showBrandChart,
    showGenericChart,
    brandPrice,
    dosage,
    quantity,
    priceBrandTable,
    prices,
    priceTable,
    form
  } = props.priceHistory;
  let {
    brandName,
    drugName,
    drugType,
    brandType,
    genericDrugName,
    brandDrugName
  } = props.priceHistory.drugNames;
  const [dynamicChartData, setdynamicChartData] = useState({});
  let isEs = _.isEqual(i18n.language, 'es');
  useEffect(() => {
    setdynamicChartData({
      location: window.location.origin,
      searchDrugName: props.seoName
    });
  }, [props.seoName]);
  return showBrandChart || showGenericChart ? (
    <div className="white-bg">
      <div className="priceHistoryContainer">
        <h2 id="price-history-heading">
          {isEs
            ? `${t('Price History & Information')} ${name}`
            : `${name} ${t('Price History & Information')}`}
        </h2>
        {!isSingleElement && !_.isEmpty(brandPrice) ? (
          <div className="PriceChart">
            <PriceChart
              drugName={`${drugName} (${t(drugType)}) ${t(
                '&'
              )} ${brandName} (${t(brandType)})`}
              isBrand={true}
              isSingleElement={isSingleElement}
              priceData={brandPrice}
              lineKeys={['brandprice', 'price', 'singlecareprice']}
              displayKeys={[
                {
                  value: isEs
                    ? `${t('Average')} ${t('Retail Price')} ${brandDrugName}`
                    : `${t('Average')} ${t(
                        'retail price'
                      )} for ${brandDrugName}`,
                  type: 'line',
                  color: '#4a474f'
                },
                {
                  value: isEs
                    ? `${t('Average')} ${t('Retail Price')} ${genericDrugName}`
                    : `Avg ${t('retail price')} for ${genericDrugName}`,
                  type: 'line',
                  color: '#716c78'
                },
                {
                  value: isEs
                    ? `${t(
                        'Average'
                      )} promedio de ${genericDrugName} en SingleCare`
                    : `Avg SingleCare ${t('price')} for ${genericDrugName}`,
                  type: 'line',
                  color: '#dd216b'
                }
              ]}
              dosage={dosage}
              quantity={quantity}
              form={form}
              isModalButton={false}
              dynamicChartData={dynamicChartData}
              seoName={props.seoName}
            />
            {/*<button className="embedButton">Embed</button>*/}
          </div>
        ) : (
          <div className="PriceChart">
            <PriceChart
              drugName={drugName}
              priceData={prices}
              // isBrand={isChart?.isBrand ? true : false}
              isSingleElement={isSingleElement}
              lineKeys={['price', 'singlecareprice']}
              displayKeys={[
                {
                  value: isEs
                    ? `${t('Average')} ${t('Retail Price')} ${drugName}`
                    : `${t('Average')} ${t('retail price')} for ${drugName}`,
                  type: 'line',
                  color: '#4a474f'
                },
                {
                  value: isEs
                    ? `${t('Average')} promedio de ${drugName} en SingleCare`
                    : `Avg SingleCare ${t('Price')} for ${drugName}`,
                  type: 'line',
                  color: '#dd216b'
                }
              ]}
              dosage={dosage}
              quantity={quantity}
              form={form}
              isModalButton={false}
              ndc={props.ndc}
              dynamicChartData={dynamicChartData}
              seoName={props.seoName}
            />
          </div>
        )}
        <div className="PriceChartDisclaimer">
          <PriceDisclaimer disclaimerType={'Chart'} />
        </div>
        {!isSingleElement && !_.isEmpty(priceBrandTable) ? (
          <div className="PriceTable">
            <PriceTable
              drugName={`${drugName} (${t(drugType)}) ${t(
                '&'
              )} ${brandName} (${t(brandType)})`}
              tableData={priceBrandTable}
              lineKeys={['brandprice', 'price', 'singlecareprice']}
              displayKeys={
                isEs
                  ? [
                      `${t('RetailPriceTable')} ${brandDrugName}`,
                      `${t('RetailPriceTable')} ${genericDrugName}`,
                      `Precio de ${genericDrugName} en SingleCare`
                    ]
                  : [
                      `${brandDrugName} ${t('Retail Price')}`,
                      `${genericDrugName} ${t('Retail Price')}`,
                      `${genericDrugName}  SingleCare ${t('Price')}`
                    ]
              }
              dosage={dosage}
              quantity={quantity}
              isModalButton={false}
              form={form}
            />
          </div>
        ) : (
          <div className="PriceTable">
            <PriceTable
              drugName={drugName}
              tableData={priceTable}
              lineKeys={['price', 'singlecareprice']}
              displayKeys={
                isEs
                  ? [
                      `${t('Retail Price')} ${drugName}`,
                      `Precio de ${drugName} en SingleCare`
                    ]
                  : [
                      `${drugName} ${t('Retail Price')}`,
                      `${drugName}  SingleCare ${t('Price')}`
                    ]
              }
              dosage={dosage}
              quantity={quantity}
              form={form}
            />
          </div>
        )}
        <div
          className={`PriceTableDisclaimer ${
            priceTable?.length < 2 || priceBrandTable?.length < 2
              ? 'removeMargin'
              : ''
          }`}
        >
          <PriceDisclaimer disclaimerType={'Table'} />
        </div>
      </div>
    </div>
  ) : (
    <div />
  );
};

export default withTranslation()(PriceHistory);
